import React, { useEffect, useMemo, useRef, useState } from 'react';
import LinkPlus from '../UI/LinkPlus.js';
import styles from './ListaLinksScroleable.module.css';

const ListaLinksScroleable = (props) => {
  const path = props.path;
  const lista = props.lista;
  const cantVisibles = props.cantVisibles;
  const altoFijo = props.altoFijo;
  const contenedorRef = useRef(null);
  const [altoItem, setAltoItem] = useState(30);
  const cantidadVisible = cantVisibles || 10;

  useEffect(() => {
    const medirAltoItem = () => {
      if (!contenedorRef.current) {
        return;
      }

      const primerItem = contenedorRef.current.querySelector(`.${styles.listItem}`);
      if (!primerItem) {
        return;
      }

      const estilo = window.getComputedStyle(primerItem);
      const marginTop = Number.parseFloat(estilo.marginTop) || 0;
      const marginBottom = Number.parseFloat(estilo.marginBottom) || 0;
      const altoReal = primerItem.getBoundingClientRect().height + marginTop + marginBottom;

      if (altoReal > 0) {
        setAltoItem(altoReal);
      }
    };

    medirAltoItem();
    window.addEventListener('resize', medirAltoItem);

    return () => {
      window.removeEventListener('resize', medirAltoItem);
    };
  }, [lista]);

  const itemsVisible = lista ? Math.min(lista.length, cantidadVisible) : cantidadVisible;
  const alto = useMemo(() => `${Math.ceil(altoItem * itemsVisible)}px`, [altoItem, itemsVisible]);

  return (
    <div
      ref={contenedorRef}
      className={`${styles.scrollContainer}`}
      style={{
        maxHeight: alto,
        overflowY: 'auto',
        minHeight: altoFijo ? alto : 'auto',
      }}
    >
      {lista &&
        lista.map((item) => (
          <LinkPlus className={`${styles.listItem}`} key={item.id} to={path + item.id}>
            {item.descripcion ? item.descripcion : item.nombre}
          </LinkPlus>
        ))}
    </div>
  );
};

export default ListaLinksScroleable;
